interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  tone?: "primary" | "accent" | "secondary";
}

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  tone = "primary",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`max-w-2xl ${isCenter ? "mx-auto text-center" : ""}`}>
      <span
        className={`inline-flex items-center gap-2 h-7 px-3 rounded-full text-xs font-label font-medium tracking-wide ${toneMap[tone]}`}
      >
        <span className="w-1.5 h-1.5 rounded-full bg-current" />
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
        {title}
      </h2>
      {desc ? (
        <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
          {desc}
        </p>
      ) : null}
    </div>
  );
}